import { getLeFEOrigin } from '@utils/util';

export const TechGoodsScene = () => (
    <iframe className="admin-iframe" title="场景管理" src={`${getLeFEOrigin()}/#/runtime/admin/tech_goods_scene`} />
);
